import { MACKENZIE_HYBRIDA_APPLICATION_ID } from './constants'

interface IExternalReference {
  applicationId: number
}

const isUserExternalReferenceBlockedToChangeRoles = (userExternalReference: IExternalReference[]) =>
  userExternalReference?.some(
    ({ applicationId }) => applicationId === MACKENZIE_HYBRIDA_APPLICATION_ID,
  )

export default isUserExternalReferenceBlockedToChangeRoles
